import React, { ReactElement, useState } from 'react';

import { Theme, Container, Typography, Button } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import AlmeInput from '../AlmeInput/AlmeInput';
import { AlmeLaunchIvaMessageEventData } from '@alme/post-message-api/AlmeLaunchIvaMessageEventData';
import AlmeTenantMenu from './AlmeTenantMenu';
import { defaultAccessKey } from '../../utils/PersonaUtils';
import { AlmeLaunchToolsConfig } from './AlmeLaunchToolsConfig';
import AlmeLanguageMenu from '../AlmeTestPage/AlmeLanguageMenu/AlmeLanguageMenu';

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            border: `solid 1px ${palette.divider}`,
            padding: spacing(1),
        },
    }),
);

interface AlmeLaunchToolsProps {
    almeConfig: AlmeLaunchToolsConfig;
}

export default function AlmeLaunchTools(props: AlmeLaunchToolsProps): ReactElement {
    const classes = useStyles();
    const [accessKey, setAccessKey] = useState<string>(defaultAccessKey);

    const onSendPostMessage = (input?: string) => {
        if (accessKey === defaultAccessKey) {
            const data = {
                message: {
                    type: "LaunchIva",
                    source: "client",
                    launchPointName: "Global",
                    launchParameter: "MainPage",
                    accessKey: accessKey,
                },
            } as AlmeLaunchIvaMessageEventData;

            if (input && typeof input === 'string') {
                data.message.launchQuestion = input;
            }

            window.postMessage(data, window.location.origin);
        }
        else {
            const data = {
                message: {
                    type: "LaunchIva",
                    source: "client",
                    accessKey: accessKey,
                },
            } as AlmeLaunchIvaMessageEventData;

            if (input && typeof input === 'string') {
                data.message.launchQuestion = input;
            }

            window.postMessage(data, window.location.origin);
        }
    };

    return (
        <Container className={classes.root}>
            <Typography variant='subtitle1'>Launch Tools</Typography>
            <Button
                variant={props.almeConfig.launchTools.launchButton.variant}
                color={props.almeConfig.launchTools.launchButton.color}
                onClick={() => { onSendPostMessage(); }}>Launch IVA</Button>
            <AlmeInput almeConfig={props.almeConfig.launchTools.launchPoint} submitFunc={onSendPostMessage} inputId='alme-launch-tools-input-box' submitId='alme-launch-tools-submit-button' ></AlmeInput>
            <AlmeTenantMenu setAccessKey={setAccessKey} />
            <AlmeLanguageMenu />
        </Container>
    );
}